import authenticationReducer from "./reducers";

// import * as authenticationSelectors from "./selectors";
import * as authenticationOperations from "./operations";
import * as authenticationTypes from "./types";

export {
    authenticationOperations,
    authenticationTypes
};

export default authenticationReducer;
